import axios from 'axios';
import { getAuthHeaders, getAuthHeadersWithContentType } from '../utils/auth';

const ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL || 'http://localhost:8001';

export interface ApiKey {
  id: number;
  key: string;
  created_at: number;
  user_id: number;
}

export const getApiKeys = async (): Promise<ApiKey[]> => {
  const response = await axios.get<ApiKey[]>(`${ADMIN_API_URL}/api-keys/`, {
    headers: await getAuthHeaders()
  });
  // Убеждаемся, что возвращаем массив
  return Array.isArray(response.data) ? response.data : [];
};

export const createApiKey = async (): Promise<ApiKey> => {
  const response = await axios.post<ApiKey>(`${ADMIN_API_URL}/api-keys/`, {}, {
    headers: await getAuthHeadersWithContentType()
  });
  return response.data;
};

export const getApiKeyCount = async (): Promise<number> => {
  const response = await axios.get<number>(`${ADMIN_API_URL}/api-keys/count`, {
    headers: await getAuthHeaders()
  });
  return response.data;
};
